<template>
  <div class="wenkoo-container">
    <div class="header">
      <div>
        <img src="../../assets/wenkoo/logo.png">
        <div class="guide" @click="showGuide(true)">
          <div class="dot"><div></div></div>
          提问引导
        </div>
      </div>
      <div>
        <el-input
            placeholder="请输入..."
            prefix-icon="el-icon-search"
            v-model="serchText">
        </el-input>
        <el-button @click="getArticle">搜索</el-button>
      </div>
    </div>
    <div class="inner">
      <div class="left-inner">
        <div class="Dialogue">
          <ul class="infinite-list" style="overflow:auto">
            <li class="infinite-list-item-default" v-if="defaultFlag">
<!--              <div class="ai-inner">-->
<!--                <img src="../../assets/wenkoo/AI.png" class="AIavatar">-->
<!--                <pre class="content">请告诉我您想了解的内容，例如：给我推荐教育职称相关的文章等</pre>-->
<!--              </div>-->
              <div class="avatar">
                <img src="https://wenkoo.com.cn/chat/_nuxt/ai-logo.dc0b56e5.png">
              </div>
              <div class="chat-content">
                <div class="title">
                  <div>你好，我是文可知识助手</div>
                  <div>作为你的智能知识助手，我可以帮你提供灵感和创意、创作文案，又可以与你聊天，答疑解惑。我还可以提供一些创意玩法。请告诉我你想问什么，让我们开始对话吧!</div>
                </div>
                <div class="defaults-inner">
                  <div class="item" v-for="(item,index) in defaults" :key="index" @click="defaultSend(item)">
                    <div>
                      <span>{{item.title}}</span>
                      <img class="try" :src="require('@/assets/wenkoo/try.png')">
                    </div>
                    <div>{{item.content}}</div>
                  </div>
                </div>
              </div>
            </li>
            <li v-for="(item,index) in chatList" class="infinite-list-item" v-else>
              <div class="ai-inner" v-if="item.role === 'assistant'">
                <img src="../../assets/wenkoo/AI.png" class="AIavatar">
                <img src="../../assets/wenkoo/zzzBackground.gif" class="zzz" v-if="item.flag">
                <pre class="content" v-else v-html="item.content"></pre>
              </div>

              <div class="user-inner" v-else>
                <pre class="content">{{item.content}}</pre>
                <img src="../../assets/wenkoo/userAvatar.png" class="userAvatar">
              </div>
            </li>
          </ul>
        </div>
        <div class="input">
          <div class="again-inner" v-if="chatList.length !== 0">
            <div class="again-stop" @click="again">{{againAndstop}}</div>
          </div>
          <div class="chat">
            <el-input v-model="chatText" placeholder="请输入..." @change="send"></el-input>
          </div>
          <el-button @click="send">发送</el-button>
        </div>
      </div>
      <div class="right-inner">
        <img src="../../assets/wenkoo/correlation.png" class="correlation">
        <div class="article-inner">
          <ul class="infinite-list" style="overflow:auto">
            <li v-for="(item,index) in articleList" class="infinite-list-item" @click="lookArticle(item)">
              <div class="title" v-html="item.Abstract"></div>
              <div class="author">
                <span v-html="item.Title"></span>
                <span>{{ item.MagazineName }} {{item.Year}}年 第{{item.Issue}}期</span>
              </div>
            </li>
            <div class="buttom-inner">
              <div class="noMore" v-if="no">暂无更多</div>
              <div class="loadingMore" @click="getArticle('more')" v-else>加载更多</div>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <GuideDialog :show="showDialog" @showGuide="showGuide" @copyText="copyText"></GuideDialog>
    <ArticleDialog :showArticle="showArticle" :info="detailInfo" @showArticleDialog="showArticleDialog"></ArticleDialog>
  </div>
</template>

<script>
import GuideDialog from "@/page/wenkoo/components/guideDialog";
import ArticleDialog from "@/page/wenkoo/components/articleDialog";
import {ChatSession, GetArticleList, GetArticleListDetail} from '@/api/wenkoo'
export default {
  name:'wenKoo',
  components:{
    GuideDialog,
    ArticleDialog
  },
  data(){
    return {
      serchText:'',
      chatText:'',
      chatList: [],
      chatFlag:true,
      articleList:[],
      showDialog:false,
      showArticle:false,
      page:1,
      detailInfo:'',
      no:false,
      againAndstop:'停止查询',
      againText:'',
      defaults:[
        {
          id: 1,
          title: '党建学习报告',
          content:
              '你是一个专业的中国党建学习编辑，使用严谨的语言，结合本文和最新党的政策，写一篇关于本文的党建学习报告，字数需要达到500字:《坚持自我革命 永葆青春活力》',
          prompt: `
            内容：2022年12月6日，中共中央政治局召开会议，分析研究2023年经济工作；听取中央纪委国家监委工作汇报，研究部署2023年党风廉政建设和反腐败工作。会议强调：“要时刻保持解决大党独有难题的清醒和坚定，时刻保持永远在路上的坚韧和执着，进一步增强坚定不移全面从严治党的政治定力，把严的基调、严的措施、严的氛围长期坚持下去，把新时代党的伟大自我革命进行到底。”
            把新时代党的伟大自我革命进行到底，体现了党中央坚持全面从严治党，深入推进反腐败斗争，营造风清气正、海晏河清政治生态的坚定决心。勇于自我革命是中国共产党在百年奋斗中积累的宝贵经验，是中国共产党永葆青春活力的基因密码、动力源泉，是我们党最鲜明的品格和最大的优势。我们要始终坚持党的自我革命，永葆党的青春活力，推动中华民族伟大复兴号巨轮乘风破浪、扬帆远航。
            要在践行初心使命中坚持自我革命。为中国人民谋幸福、为中华民族谋复兴，是中国共产党的初心和使命，一百多年来一以贯之，矢志不渝。不忘初心，方得始终；牢记使命，砥砺前行。百年党史，既是一部波澜壮阔的社会革命史，也是一部激浊扬清的自我革命史。百年来，我们党正是笃志笃行初心使命，才得到了人民群众的拥护和支持，取得了前进道路上的一个又一个胜利，实现了中华民族从站起来、富起来到强起来的伟大飞跃。初心易得，始终难守。要做到不忘初心使命，就必须保持自我革命的精神，在践行初心使命中坚持问题导向，不断检视自己，做好“体检”，修正错误、改正缺点，以刀刃向内、刮骨疗毒的勇气，坚决同一切弱化党的先进性和纯洁性、危害党的肌体健康的问题和现象作斗争，在守初心、担使命中推动经济社会发展行稳致远。
            要在推动社会革命中坚持自我革命。习近平总书记指出：“在新时代，我们党必须以党的自我革命来推动党领导人民进行的伟大社会革命。” 党的二十大报告也明确要求，“必须持之以恒推进全面从严治党，深入推进新时代党的建设新的伟大工程，以党的自我革命引领社会革命”。在进行社会革命的同时不斷进行自我革命，以伟大自我革命引领伟大社会革命，是我们党区别于其他政党最显著的标志，也是我们党不断从胜利走向新的胜利的关键所在。从百年党史中我们能够明确地发现和体验到，正是我们党坚持自我革命的勇气，一次次拿起“手术刀”排毒祛腐疗伤，一次次靠自己解决了自身问题，团结带领全国各族人民创造了中国革命、建设、改革和新时代的伟大成就。如今，我们正朝着全面建成社会主义现代化强国、以中国式现代化全面推进中华民族伟大复兴的奋斗目标奋勇迈进。前进的道路从来不是一帆风顺，有时会经历疾风暴雨，需要我们时刻保持解决大党独有难题的清醒和坚定、坚决和谨慎，不断发扬自我革命精神，坚定自我革命勇气，在新的赶考之路上向历史和人民交出新的优异答卷。
            要在增强自我能力中坚持自我革命。习近平总书记在党的二十大报告中指出：“经过不懈努力，党找到了自我革命这一跳出治乱兴衰历史周期率的第二个答案，自我净化、自我完善、自我革新、自我提高能力显著增强，管党治党宽松软状况得到根本扭转，风清气正的党内政治生态不断形成和发展，确保党永远不变质、不变色、不变味。”这概括了党的十八大以来，以习近平同志为核心的党中央全面从严治党取得历史性成就、发生历史性变革的重要原因和重要经验。自我净化、自我完善、自我革新、自我提高，是党的自我革命的生动实践和具体体现，也是我们党立于不败之地、永葆青春活力的基因密码。党的十八大以来，以习近平同志为核心的党中央始终坚持刀刃向内的勇气，以“得罪千百人，不负十四亿”的使命担当，打出一套自我革命的“铁砂掌”、“组合拳”，使全面从严治党成为新时代党的自我革命的伟大实践，形成了党自我净化、自我完善、自我革新、自我提高的制度规范体系，风清气正的党内政治生态不断形成和发展。新时代，要坚持不懈探索提升自我能力的有效途径，积极应对“四大考验”、“四种危险”，以永远在路上的清醒和坚定，坚持不懈把全面从严治党向纵深推进，确保党始终成为中国特色社会主义事业的坚强领导核心。`,
          // keyword: '成都旅游,成都旅游攻略,成都美食',
        },
        {
          id: 2,
          title: '中小学科普文章',
          content:
              '你是一个专业的少儿编辑，面向小学生读者来重写《神奇小猫爪的秘密》这篇文章，文风有趣具有童心，吸引孩子来阅读，字数需要达到300字',
          prompt: `
            内容：大家是否留意过猫咪的爪子？猫爪的肉垫小小的，软而饱满，爪尖晶莹透亮，细嗅之下有一股特殊的气味。今天，知力君就来给大家分享关于它的小秘密。
            毛茸茸的猫爪虽然可爱，但它也是猫咪用来保护自己的利器——猫咪感到害怕时，会用爪子抓伤身边的生物。所以，我们不要随便摸猫、抓猫哟！
            小猫爪，大用途
            猫的前足有五趾，但后足只有四趾，这是因为其后足的第五趾已经完全退化了。一些食肉动物行走时是脚掌着地的，猫则不同，是脚趾着地的，这种趾端行走方式非常适合奔跑。
            猫的掌骨被韧带组织牢牢束缚，脚掌具有富含脂肪和弹性纤维的厚厚肉垫，可以帮助猫减缓快速奔跑和向下跳落时所受到的震动。
            小小的肉垫对猫而言至关重要，它具有消音、散热、减震、防滑等多种功能，还能成为猫咪的感受器。
            超多功能，一只解决
            猫掌骨垫（俗称肉垫）的颜色通常与其鼻头的颜色一致，由一个个小肉球组成。前爪的肉垫除了5个分离的“指球”和3个并排的“掌球”，内侧上端还有一个行走时不接触地面的肉球，即腕垫，又称“手根球”。
            手根球是猫在进化过程中退化的爪趾头，同样富含脂肪组织，触感与其他肉球相似。手根球能够减缓猫咪跳跃着地时受到的冲击力，且具有防滑作用，可帮助猫降低行走时产生的声音。
            猫与狗皮肤上的汗腺都不发达，并不能像人类那样大汗淋漓，在皮肤辐射散热之外，狗主要使用嘴巴和舌头进行散热，而猫则是通过爪子上的肉垫。或因气温升高，或因情绪紧张、激动，猫爪便会出汗，假如你发现猫咪的爪子有些潮湿，可能它正在流汗。
            猫咪脚掌的肉垫上分布着大量神经，十分敏感，可让猫感知环境。猎物在地面上活动会产生细微的振动——猫可以通过肉垫接收这些信号，以判断猎物的行动。而手根球边缘的长毛与猫胡须的功能相似，捕捉猎物时，它可以帮助猫判断猎物是否还活着。
            猫不喜欢被积雪覆盖或被太陽炙烤的地面，因为它们的肉垫周围没有茂密的被毛，因此相对脆弱，温度骤升骤降或压力都会对其造成伤害。猫咪信任你的标志之一就是允许你轻握或抚摸它们敏感又脆弱的爪子。
            猫能够悄无声息地奔跑、跳跃、攀爬，是因为猫爪上的肉垫是在层层脂肪的包裹下形成的。猫可以自由控制趾端锐甲的伸缩，再加上猫爪上厚厚的防滑肉垫，便可以将自己的行走调至“静音模式”，靠近猎物时不易被察觉，猫咪因此成为优秀的潜伏者和狩猎者。
            猫爪密布趾间腺，出汗时因其潮湿，容易沾染土壤中的放线菌（一类呈菌丝状生长、主要以孢子繁殖的丝状菌，由于菌落呈放射状而得名），而猫爪上的毛具有保湿作用，容易滋生假单胞菌（一类专性需氧的杆菌，存在于土壤、淡水和海水中）和变形杆菌（一类广泛分布于自然界的杆菌，为人体正常菌群）。这几种菌相互作用时，会产生一种酵母味，闻起来就像甜香的玉米片或爆米花，这种气味附着在爪子上，温热的猫爪便有了淡淡的爆米花气味。
            猫狗的爪子排出的汗液和分泌物，给细菌、真菌和微生物提供了繁殖的温床。不同的菌群会散发出不一样的气味，有些像香甜的爆米花，有些像焦糖或巧克力，有些像阳光晒过的棉被，当然也有一些是酸酸的汗臭味。大家无须过分担心猫咪和狗狗爪子上的气味，只要皮肤上的真菌和细菌处于平衡状态，它们便是健康的。
            一只小小的猫爪，竟藏着那么多属于猫咪的身体秘密。你还想了解动物的哪些器官？请扫描二维码，告诉知力君，将有机会看到解答文章哟！
            知识链接
            与人类指甲从肉里长出来不同，猫的趾甲是从骨头里生长出来的，修剪起来较为繁琐。猫咪去甲手术可以一劳永逸，但这种手术剪断了它们的骨头，剥夺了它们的防御武器，其效果相当于去掉人类的一节手指。`,
          // keyword: '英语学习,小学三年级英语学习,基础课程',
        },
        {
          id: 3,
          title: '旅游推广文章',
          content: '请帮我把《成都骑游全攻略》这篇旅游推荐文章改成兰州市的旅游推广',
          prompt: `
            内容：成都这个城市地处平原,四面环山,交通也发达,景色优美,除了要拥有好的骑游装备以外,选择最适合的路线才是最能达到旅行目的。
        　　
            　　骑游必备装备
            　　
            　　A、 一辆好的自行车。刚刚入行或者是只是将骑游当做平时休闲方式的车友,可选择普通山地车。如果想去更远的地方,如50公里以上中长途就需要专业的山地车,较好的山地车品牌有捷安特和美利达。价格在1000~2000元。同时这两个品牌还有专门为女性设计的山地车,如捷安特MIMI系列和美利达维多利亚系列,价格大都在1200~1600元不等。
            　　
            　　B、一套专业的服装。想要在骑车的时候看起来更专业,更拉风,一套好的骑行服必不可少,根据自己体形选择S、M、L、XL。也可以定做骑行服上的图案。 一般在150~200元左右一套,比较好的品牌有CCN和烽火轮。
            　　C、头盔。头盔是骑行过程中必不可少的装备,它可以在出现危险时有效地保护头部,当在高速骑行摔倒时,头盔会通过破碎吸收能量,有效保护大脑。比较好的品牌如BELL,价格大概在500~1000元。也有价格在200~400元的LIMAR。但是目前头盔的花纹还不能自己定做,这点还是比较遗憾。
            　　D、鞋子。一般车友只要在骑行的时候穿上平底鞋就可以了,但是鞋底最好是硬一点。专业的骑游者就要穿专用的锁鞋了。
            　　E、其他:手套和眼镜。手套用于在骑行发生意外时保护双手,眼镜可以用来防止阳光强烈的时候视线不清晰等。
            　　
            　　骑行路线推荐
            　　
            　　一条好的骑游路线是非常重要的,路线设计原则基本上为在同一条路线上,尽可能包罗更多的景点、景区,设计成环形线路以增加路线中景点。下面就为大家推荐几条骑游路线供参考:
            　　
            　　1、短途
            　　黄龙溪:往返约100公里(大路、小路均可)适合刚参加骑游的车友或者是休闲的专业车友,路途比较平坦,难度不大。行径华阳,可以顺便走进翠竹林掩映的农家乐,享受远离都市的清净。休息之后再騎行至黄龙溪古镇,可以摇桨弄舟,也可以游览古镇。还可以吃到特色美食,像太安鱼、蒋排骨、正兴泥鳅、珍珠豆腐、酥皮肘子等。
            　　洛带: 成都-洛带-金龙寺(山下)-洛带-成都
            　　龙泉驿:成都-龙泉驿-柏合(万亩果园)-华阳-成都
            　　
            　　2、中长途
            　　云顶山: 往返约120公里,具体路线如:成都—龙潭寺—石板滩—清泉—云顶—清泉—洛带—成都。去云顶山的路有很多较长的上坡,适合有经验的车友。沿途可以经过很多风景优美的地方,不仅可以享受大自然的美好,还可以感受天地任我行的惬意,并且可以吃到很多特色小吃。累了的话,几个车友一起聚聚餐,感受友情的美好。这样比较长的旅行最好是几个车友一起行动,路上方便相互照顾。
            　　
            　　3、长途
            　　青城山大环线:往返约260公里,具体路线如:成都—双流—新津—蒲江—西来古镇—邛崃—大邑—怀远—街子—两河乡—青城后山—前山—都江堰—成都(来回要两天或以上)所需时间较长,而且沿途路线也比较艰难,需要更大的毅力,适合有经验的车友组队参加。去青城的这一路风景自然不必多说,还可以了解很多风土人情。同时,最好在出发时准备好睡袋、干粮等短途骑游可能用不上的物品。
            　　
            　　夜骑乐趣
            　　
            　　大多数人对骑游的想象都停留在白天,殊不知晚上也是可以骑游的,而且还能体验到白天所不能感受的别样乐趣。
            　　成都周边较好的夜游路线是温江或者华阳。一般晚上6点左右出发,9点左右回来。这两条路线沿途照明情况都比较好,到达目的地之后还可以和车友们聚餐,吃当地小吃,喝夜啤酒,大家一起FB(腐败)。
            当然,夜骑也必不可少要带上专业的装备,头盔、衣服、手套等,同时还有很重要的就是车前灯和尾灯了,用来防止晚上因视线不好引起的危险。`,
          // keyword: '互通有无',
        },
        {
          id: 4,
          title: '读后感撰写',
          content:
              '我是一名90后中学老师，帮我写一篇《谱写新时代生态文明建设新篇章》文章的读后感，字数300字，文风富有感情，结合生活实际案例，要具有个人工作学习特色',
          prompt: `
            内容：全国生态环境保护大会于2023年7月17日至18日在北京召开。习近平总书记在会上发表重要讲话，全面总结我国生态文明建设取得的举世瞩目的巨大成就特别是历史性、转折性、全局性变化，深入分析当前生态文明建设面临的形势，深刻阐述新征程上推进生态文明建设需要处理好的重大关系，系统部署全面推进美丽中国建设的战略任务和重大举措，为新时代新征程建设人与自然和谐共生的现代化提供了根本遵循。
              生态文明建设是关系中华民族永续发展的根本大计。党的二十大擘画了全面建设社会主义现代化国家、以中国式现代化全面推进中华民族伟大复兴的宏伟蓝图，提出到2035年“广泛形成绿色生产生活方式，碳排放达峰后稳中有降，生态环境根本好转，美丽中国目标基本实现”的目标任务，围绕“推动绿色发展，促进人与自然和谐共生”作出重大部署。要深刻认识到，中国式现代化是人与自然和谐共生的现代化，尊重自然、顺应自然、保护自然是全面建设社会主义现代化国家的内在要求。同时必须清醒看到，我国生态环境保护结构性、根源性、趋势性压力尚未根本緩解。我国经济社会发展已进入加快绿色化、低碳化的高质量发展阶段，生态文明建设仍处于压力叠加、负重前行的关键期。习近平总书记在会上强调，今后5年是美丽中国建设的重要时期，要牢固树立和践行绿水青山就是金山银山的理念，把建设美丽中国摆在强国建设、民族复兴的突出位置。只有坚持以习近平生态文明思想为指导，站在人与自然和谐共生的高度谋划发展，像保护眼睛一样保护自然和生态环境，坚定不移走生产发展、生活富裕、生态良好的文明发展道路，才能谱写新时代生态文明建设新篇章，实现中华民族永续发展。
              新征程上，广东肩负着在推进中国式现代化建设中走在前列的使命任务，在生态文明建设中走在前列也是题中应有之义。全省生态环境系统要进一步深刻领悟“两个确立”的决定性意义，增强“四个意识”、坚定“四个自信”、做到“两个维护”，全面贯彻落实党中央决策部署，以更高站位、更宽视野、更大力度来谋划和推进新征程生态环境保护工作，深入推进绿美广东生态建设，在打造人与自然和谐共生的现代化广东样板上取得新突破，让南粤大地天更蓝、山更绿、水更清、生态更优美。`,
        },
      ],
      defaultFlag:true
    }
  },
  mounted(){
    if(!this.user_unique_code){
      this.$store.commit('setShowLoginRegister', true)
      this.$store.commit("setMustLogin", true);
    }
    this.getArticle()
  },
  computed:{
    user_unique_code(){
      return this.$store.state.user_unique_code;
    }
  },
  methods:{
    async getArticle(type){
      if(type === 'more'){
        this.page++
      }else{
        this.page = 1
        this.articleList = []
      }
      let params = {
        inputWords:this.serchText || 'ai',
        pageIndex:this.page,
        pageSize:10
      }
      let result = await GetArticleList(params)
      if(result.data.Code === '0' && result.data.Data.Items.length !== 0){
        this.articleList.push(...result.data.Data.Items)
      }else{
        this.no = true
        this.articleList = []
      }
    },
    async send(){
      this.defaultFlag = false
      if(this.chatFlag){
        if(this.chatText.trim() === '') return
        this.againText = this.chatText
        this.chatFlag = false
        this.chatList.push({
          role:'user',
          content:this.chatText
        })
        let arr = Array.from(this.chatList)
        this.chatList.push({
          role:'assistant',
          content:'',
          flag:true
        })
        let params = {
          user_code:this.user_unique_code,
          list:arr
        }
        this.serchText = this.chatText
        this.chatText = ''
        this.$nextTick(()=>{
          const domWrapper = document.querySelector('.Dialogue');
          domWrapper.scrollTop = domWrapper.scrollHeight
        })
        let result = await ChatSession(params)
        this.getArticle()
        if(result.data.code === '1'){
          this.chatFlag = true
          this.chatList[this.chatList.length -1].flag = false
          this.chatList[this.chatList.length -1].content = result.data.data
          this.againAndstop = '重新回答'
        }else{
          this.$message({
            message:'当前服务器访问量过大，请稍后尝试',
            type:'error'
          })
        }
      }else{
        this.chatText = ''
      }
    },
    defaultSend(item){
      this.chatText = item.content+item.prompt
      this.send()
    },
    showGuide(type){
      this.showDialog = type
    },
    showArticleDialog(type){
      this.showArticle = type
    },
    async lookArticle(item){
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.detailInfo = null
      let params = {
        titleID:item.TitleID,
        issue:item.Issue
      }
      let result = await GetArticleListDetail(params)
      if(result.data.code === 0){
        this.detailInfo = result.data.data
        this.detailInfo.Year = item.Year
        this.detailInfo.Issue = item.Issue
        loading.close();
        this.showArticle = true
      }
    },
    copyText(text){
      this.chatText = text
    },
    again(){
      if(this.againAndstop === '停止查询'){
        this.$cancel()
        this.againAndstop = '重新回答'
        this.chatList.pop()
      }else{
        this.againAndstop = '停止查询'
        this.chatText = this.againText
        this.chatFlag = true
        this.send()
      }
    }
  }
}
</script>

<style lang="less">
.wenkoo-container{
  width: 100%;
  height: calc(100%);
  border-right: 1px solid #E6E6E6;
  border-left: 1px solid #E6E6E6;
  border-bottom: 1px solid #E6E6E6;
  .header{
    height: 80px;
    border-bottom: 1px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    div:nth-child(1){
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img{
        width: 235px;
        height: 60px;
      }
      .guide{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 88px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #CC3F1F;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #CC3F1F;
        cursor: pointer;
        .dot{
          outline-color: #cc3f1f;
          outline-width: 2px;
          outline-style: solid;
          --tw-border-opacity: 1;
          border-width: 2px;
          border-radius: 100px;
          width: 10px;
          height: 10px;
          margin-right: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          div{
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #cc3f1f;
          }
        }
      }
    }
    div:nth-child(2){
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .el-input{
        width: 444px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid #E6E6E6;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        border-radius: 8px 0px 0px 8px;
      }
      .el-button{
        width: 83px;
        height: 40px;
        background: #CC3F1F;
        border-radius: 0px 8px 8px 0px;
        color: #FFF;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        margin-left: -2px;
      }
    }
  }
  .inner{
    width: 100%;
    height: calc(100% - 81px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .left-inner{
      height: 100%;
      flex: 1 1 0%;
      border-right: 1px solid #E6E6E6;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .Dialogue{
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #E6E6E6;
        overflow-y: auto;
        padding-bottom: 54px;
        .infinite-list{
          .infinite-list-item-default{
            background: #F5F7FA;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 30px;
            .avatar{
              img{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 10px;
              }
            }
            .chat-content{
              .title{
                margin-bottom: 20px;
                div:nth-child(1){
                  font-size: 24px;
                  font-family: AlibabaPuHuiTiM;
                  color: #303133;
                  margin-bottom: 10px;
                }
                div:nth-child(2){
                  font-size: 16px;
                  font-family: AlibabaPuHuiTiR;
                  color: #303133;
                }
              }
              .defaults-inner{
                display: flex;
                justify-content: space-around;
                align-items: flex-start;
                flex-wrap: wrap;
                .item{
                  width: calc(50% - 35px);
                  height: 100px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  align-items: flex-start;
                  padding: 16px 9px;
                  background: #FFFFFF;
                  margin-bottom: 20px;
                  border-radius: 10px;
                  div:nth-child(1){
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    span{
                      font-size: 18px;
                      font-family: AlibabaPuHuiTiB;
                      color: #303133;
                      margin-right: 5px;
                    }
                    img{
                      width: 38px;
                      height: 20px;
                      display: none;
                    }
                  }
                  div:nth-child(2){
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    color: #606266;
                  }
                }
                .item:hover{
                  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
                  cursor: pointer;
                  .try{
                    width: 38px;
                    height: 20px;
                    display: block;
                  }
                }
              }
            }
          }
          .infinite-list-item{
            .ai-inner{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              background: #F5F7FA;
              padding:20px 30px;
              margin-bottom: 20px;
              .AIavatar{
                width: 40px;
                height: 40px;
                margin-right: 10px;
                border-radius: 50%;
              }
              .zzz{
                width: 33px;
                height: 23px;
                margin-top: 8px;
              }
              .content{
                width: 670px;
                font-size: 14px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;
                white-space: pre-wrap;
                overflow-wrap: break-word;
                margin-top: 8px;
              }
            }
            .user-inner{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding:20px 30px;
              margin-bottom: 20px;
              .userAvatar{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-left: 10px;
              }
              .content{
                font-size: 14px;
                font-family: AlibabaPuHuiTiR;
                color: #303133;
                white-space: pre-wrap;
                overflow-wrap: break-word;
                background: #EBF5FF;
                border-radius: 6px;
                padding: 4px 10px;
              }
            }
          }
        }
      }
      .input{
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .again-inner{
          position: absolute;
          left: 0;
          top:-54px;
          width: 100%;
          padding: 10px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #FFF;
          .again-stop{
            width: 88px;
            line-height: 32px;
            border-radius: 6px;
            border: 1px solid #C0C4CC;
            font-size: 12px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
            text-align: center;
            cursor: pointer;
          }
        }
        .chat{
          width: 100%;
          height: 100%;
          .el-input{
            height: 100%;
            .el-input__inner{
              height: 100%;
              border: none;
            }
          }
        }
        .el-button{
          width: 120px;
          height: 40px;
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #FFFFFF;
          background: #303133;
          box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
          border-radius: 8px;
          margin-right: 30px;
        }
      }
    }
    .right-inner{
      height: 100%;
      flex-basis: 45%;
      padding:0 20px;
      .correlation{
        width:82px;
        height: 26px;
        margin: 20px 0;
      }
      .article-inner{
        width: 100%;
        height: calc(100% - 66px);
        overflow-y: auto;
        .infinite-list{
          .infinite-list-item{
            margin-bottom: 10px;
            border-bottom:1px solid rgb(230 230 230);
            cursor: pointer;
            .title{
              font-size: 18px;
              font-family: AlibabaPuHuiTiM;
              color: #606266;
              margin-bottom: 10px;
              white-space: pre-wrap;
            }
            .author{
              font-size: 13px;
              font-family: AlibabaPuHuiTiM;
              color: #909399;
              margin-bottom: 6px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
          .infinite-list-item:hover{
            .title{
              color:#CC3F1F;
            }
          }
          .buttom-inner{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 42px;
            margin-bottom: 20px;
            .loadingMore{
              width: 120px;
              height: 40px;
              font-size: 14px;
              font-family: AlibabaPuHuiTiM;
              color: #303133;
              line-height: 40px;
              background: #FFFFFF;
              border-radius: 20px;
              border: 1px solid #303133;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
